import { Button } from "controls";
import useLogout from "hooks/useLogout";
import { useTranslation } from "react-i18next";
import { SWITCH } from "./modes";

// The left-hand button is the way OUT of this dialog, and what "out" means depends on
// the mode: in SWITCH there is a branch to fall back to, so it cancels; in REQUIRED
// there is none and the only way out is to log out.
//
// `mode` is deliberately not a boolean derived from the open/close flag. It outlives
// the close animation, so this button keeps its identity all the way out instead of
// switching to the other variant mid-fade.
const Header = ({ mode, onCancel }) => {
  const { t } = useTranslation(['common']);
  const logout = useLogout();
  return (
    <div className="flex items-center justify-between p-[10px] border-b">
      <span className="uppercase font-semibold text-gray-500 ml-[5px] tracking-wide">
        {t('businessUnit')}
      </span>
      <div className="flex gap-2">
        {mode === SWITCH ? (
          <Button onClick={onCancel} variant="text">
            {t('cancel')}
          </Button>
        ) : (
          <Button
            onClick={logout}
            variant="text"
            className="!text-red-500 !bg-red-100 !font-medium !uppercase"
          >
            {t('logout')}
          </Button>
        )}
        <Button type="submit">{t('continue')}</Button>
      </div>
    </div>
  );
};

export default Header;
